export { default as GoldCard } from './component';
